import React from "react";


const CustomSalesQuotation = ()=>{
    const SSOURL = process.env.REACT_APP_SSOURL;
    return(
        <iframe src={`${SSOURL}/b2b-sales/sales-quotation`} style={{ width: "100%", height: "100%",border:"none" }} title="Dynamic Content"></iframe>
    )
}

export default CustomSalesQuotation;